import { z } from 'zod';
export const dataQualityCorrectionSchema = z.object({
    kind: z.enum(['contract', 'mapping', 'budget', 'rate', 'unknown']),
    href: z.string().regex(/^\/(?!\/)/),
    label: z.string(),
});
export const dataQualityIssueSchema = z.object({
    id: z.uuid(),
    projectId: z.uuid(),
    projectName: z.string(),
    clientName: z.string(),
    kind: z.string(),
    source: z.string(),
    priority: z.enum(['low', 'medium', 'high', 'critical']),
    status: z.enum(['open', 'resolved', 'ignored']),
    ownerId: z.uuid().nullable(),
    canManage: z.boolean(),
    canCorrect: z.boolean(),
    firstDetectedAt: z.iso.datetime(),
    lastDetectedAt: z.iso.datetime(),
    correction: dataQualityCorrectionSchema,
});
export const dataQualityIssuesResponseSchema = z.object({ data: z.array(dataQualityIssueSchema) });
export const dataQualityOwnersResponseSchema = z.object({
    data: z.array(z.object({ id: z.uuid(), name: z.string() })),
});
//# sourceMappingURL=workspace.js.map